<template>
    <settings-control label="Underline">
        <dropdown
            theme="minimalistic"
            placeholder="Select Option"
            :options="options"
            :value="textDecoration"
            native
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';
import mapFilters from '@/utils/map-filters';

const configValues = tailwindConfig.theme.textDecoration;

export default {
    name: 'settings-control-text-decoration',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            textDecoration: this.value,
        };
    },

    computed: {
        options() {
            const defaultOption = { text: 'Default', value: '' };

            const tdOptions = Object.keys(configValues)
                .filter(key => key !== 'line-through')
                .map((key) => {
                    return {
                        text: this.titleCase(configValues[key]),
                        value: configValues[key],
                    };
                });

            return [defaultOption].concat(tdOptions);
        },
    },

    watch: {
        value(newVal) {
            this.textDecoration = newVal;
        },
    },

    methods: {
        ...mapFilters(['titleCase']),

        onInput(value) {
            this.textDecoration = value;

            this.$emit('input', {
                tailwindDefinitionProp: 'textDecoration',
                value,
            });
        },
    },
};
</script>
